var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.087,
    height: 22,
    viewBox: "0 0 22.087 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #027aaa;\r\n        stroke-width: 1.8px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Cognyflo_L---Dashboard-_-option-2-side-panel-",
    "data-name": "UI-Cognyflo_L---Dashboard->-option-2-side-panel-",
    transform: "translate(-1076 -373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy-2",
    transform: "translate(830 348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-_-Oval-Mask",
    "data-name": "Oval-+-Oval-Mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(164 -56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(82 81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-1",
    cx: 4.6,
    cy: 4.6,
    r: 4.6,
    transform: "translate(6.4 0.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy",
    className: "cls-2",
    d: "M21.06,21.1A10.1,10.1,0,0,0,.94,21.1Z"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDashboard);
export default __webpack_public_path__ + "static/media/profile-dashboard.8a8bd47cb824b48d1c6dd79042adc55d.svg";
export { ForwardRef as ReactComponent };